import styled from 'styled-components'

import { colors } from '../../../../../shared/styles/colors'

export const Title = styled.div`
  color: 'rgba(62, 62, 62, 1)';
  font-weight: 700;
  font-size: 18px;
  padding-bottom: 16;
  padding-left: 24px;
  padding-top: 20px;
`
export const Paragraph = styled.div`
  color: rgba(109, 120, 125, 1);
  margin-right: 50px;
  padding-bottom: 20px;
  padding-left: 24px;
`

export const CloseButton = styled.div`
  color: ${colors.primary};
  font-weight: 700;
  font-size: 18px;
  padding-bottom: 16px;
  padding-left: 24px;
  padding-top: 20px;
  cursor: pointer;
`
export const Requisitos = styled.div`
  color: '#000000D9';
  background-color: ${colors.neutral};
  font-weight: 700;
  font-size: 18px;
  height: 50px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 24px;
`

export const CardsContainer = styled.div`
  padding-right: 15px;
  scroll-behavior: auto;
  height: 300px;
  margin-bottom: 20px;
  width: 90%;
  overflow: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 70px;
  }
`
